import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { determineDataTestIdPrefix } from '../../../helpers/propHelpers.js';

const PortalWrapper = (props) => {
    const el = document.createElement('div');
    const dataTestId = determineDataTestIdPrefix(props, 'portal-wrapper');
    el.setAttribute('data-testid', dataTestId);
    useEffect(() => {
        props.domNode.appendChild(el);
        return () => props.domNode.removeChild(el);
    }, [el, props.domNode]);
    return createPortal(props.children, el);
};

export { PortalWrapper, PortalWrapper as default };
//# sourceMappingURL=PortalWrapper.js.map
